export default __webpack_public_path__ + "static/media/Star.1fbbbe77.webp";